import request from '@/http/request'
import {
  planMockGetCourselist,
  planMockSaveMock,
  planMockDeleteMock,
  queryPaperByCourseCode,
  getPlanList
} from '@/http/api'

export const planMockGetCourselistApi = (data) => {
  return request({
    url: planMockGetCourselist,
    data
  })
}
export const planMockSaveMockApi = (data) => {
  return request({
    url: planMockSaveMock,
    data
  })
}
export const planMockDeleteMockApi = (data) => {
  return request({
    url: planMockDeleteMock,
    data
  })
}
export const queryPaperByCourseCodeApi = (data) => {
  return request({
    url: queryPaperByCourseCode,
    data
  })
}
export const getPlanListApi = (data) => {
  return request({
    url: getPlanList,
    data
  })
}